import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type FavoritesState = {
  favoriteIds: string[];
  toggleFavorite: (id: string) => void;
  isFavorite: (id: string) => boolean;
  clearFavorites: () => void;
};

export const useFavoritesStore = create<FavoritesState>()(
  persist(
    (set, get) => ({
      favoriteIds: [],

      toggleFavorite: (id) =>
        set((state) => {
          const has = state.favoriteIds.includes(id);
          return {
            favoriteIds: has
              ? state.favoriteIds.filter((x) => x !== id)
              : [...state.favoriteIds, id],
          };
        }),

      isFavorite: (id) => get().favoriteIds.includes(id),

      clearFavorites: () => set({ favoriteIds: [] }),
    }),
    {
      name: 'streampitch:favorites:v1',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
